import { ACTIONS_TYPES } from "../utils/constants";


export function craeteJobCardRequest(payload) {
  return {
    type: ACTIONS_TYPES.CREATE_JOB_CARD_REQUEST,
    payload
  }
}

export function createJobCardSuccess(response) {
  return {
    type: ACTIONS_TYPES.CREATE_JOB_CARD_SUCCESS,
    payload: response,
  }
}

export function createJobCardFailed(response) {
  return {
    type: ACTIONS_TYPES.CREATE_JOB_CARD_FAILED,
    payload: response,
  }
}

export function createJobCardReset() {
  return {
    type: ACTIONS_TYPES.CREATE_JOB_CARD_RESET,
  }
}

export function fetchJobCardsRequest() {
  return {
    type: ACTIONS_TYPES.FETCH_JOBCARDS_REQUEST,
  }
}

export function fetchJobCardsSuccess(response) {
  return {
    type: ACTIONS_TYPES.FETCH_JOBCARDS_SUCCESS,
    payload: response,
  }
}

export function fetchJobCardsFailed(error) {
  return {
    type: ACTIONS_TYPES.FETCH_PROJECTS_FAILED,
    payload: error,
  }
}

export function fetchJobCardsReset() {
  return {
    type: ACTIONS_TYPES.FETCH_JOBCARDS_RESET,
  }
}


export function fetchMyWorkspaceRequest() {
  return {
    type: ACTIONS_TYPES.FETCH_MY_WORKSPACE_JOBCARDS_REQUEST,
  }
}

export function fetchMyWorkspaceSuccess(response) {
  return {
    type: ACTIONS_TYPES.FETCH_MY_WORKSPACE_JOBCARDS_SUCCESS,
    payload: response,
  }
}

export function fetchMyWorkspaceFailed(error) {
  return {
    type: ACTIONS_TYPES.FETCH_MY_WORKSPACE_JOBCARDS_FAILED,
    payload: error
  }
}

export function viewJobSuccess(response) {
  return {
    type: ACTIONS_TYPES.VIEW_JOB_SUCCESS,
    payload: response,
  }
}

export function viewJobFailed(response) {
  return {
    type: ACTIONS_TYPES.VIEW_JOB_FAILED,
    payload: response,
  }
}

export function viewJobRequest(payload) {
  return {
    type: ACTIONS_TYPES.VIEW_JOB_REQUEST,
    payload
  }
}